import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Box, Divider, Typography } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Fonts from '../Themes/Fonts';
import { ERROR_TITLE, ERROR_MESSAGE } from '../Constants/AppConstants';

const useStyles = makeStyles({
  box: {
    paddingTop: 100,
    textAlign: 'center',
    paddingLeft: 16,
    paddingRight: 16,
  },
  title: {
    ...Fonts.style.h5,
  },
  message: {
    ...Fonts.style.p,
  },
});

const ErrorScreen = () => {
  const classes = useStyles();

  return (
    <div>
      <Divider />
      <Box className={classes.box}>
        <ErrorOutlineIcon />
        <Typography component="h5" className={classes.title}>
          {ERROR_TITLE}
        </Typography>
        <p className={classes.message}>{ERROR_MESSAGE}</p>
      </Box>
    </div>
  );
};

export default ErrorScreen;
